
//选中查询的日期类型，查询日数据、月数据
export const ALARM_CHOOSETYPE_SEARCH_TYPE='ALARM/CHOOSETYPE/SEARCH_TYPE';
//选中查询的日期时间
export const ALARM_CHOOSETYPE_MONTH_SEARCH_DATE='ALARM/CHOOSETYPE/MONTH/SEARCH_DATE';
//选中查询的日期时间
export const ALARM_CHOOSETYPE_YEAR_SEARCH_DATE='ALARM/CHOOSETYPE/YEAR/SEARCH_DATE';
